"use client";
import React, { useEffect, useRef } from "react";
import { Box } from "@quintoandar-tokko/jopijs";
import {
  setFichaInfoData,
  setInitialEditionData,
  setShowData,
} from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import { setTheme, themeFromUniven } from "@/store/slices/ThemeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import ModalWarning from "./headerFI/modalWarning/ModalWarning";
import style from "./fichaInfo.module.scss";
import Gallery from "./propertyDescription/gallery/Gallery";
import TitleProperty from "./propertyDescription/TitleProperty";
import PriceProperty from "./propertyDescription/operations/PriceProperty";
import Atributes from "./propertyDescription/Attributes";
import Contact from "./propertyDescription/contact/Contact";
import Temporary from "./propertyDescription/Temporary";
import BasicInformation from "./propertyDescription/BasicInformation";
import Location from "./propertyDescription/Location";
import FeedbackLike from "./feedback/FeedbackLike";
import ToastComponent from "./ToastFi/ToastComponent";
import ImagesEdition from "./imagesEdition/ImagesEdition";
import HeaderFI from "./headerFI/HeaderFI";
import EmptyState from "./emptyState/EmptyState";
import ErrorCapture from "../errorBoundary/index";
import PoweredByTokko from "./powered/PoweredByTokko";
import ImportantNote from "./propertyDescription/ImportantNote";
import BookAVisitButton from "./BookAVisitButton";
import OperationsBlock from "./propertyDescription/OperationsBlock";

export default function FichaInfo({ data }) {
  const { isImagesEdition, isEdition, edited_data } = useSelector(
    (ste) => ste.FichaInfoSlice
  );

  const dispatch = useDispatch();
  const pathname = usePathname();
  const params = useSearchParams();
  const { replace } = useRouter();
  const refPropertiyDescContainer = useRef();
  const noData = !data?.property?.status;
  const propertyNotExist = data?.detail === "Property not exist";
  const invalidStatus = data?.property?.status?.id === 4;
  const active = data?.property?.active || data.from_opennavent;
  const emptyState = noData || propertyNotExist || invalidStatus || !active;

  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (params.get("jwt")) {
        localStorage.setItem("jwt", params.get("jwt"));
      }
      const finalPath = `${pathname}${
        params.get("v") ? `?v=${params.get("v")}` : ""
      }`;
      replace(finalPath);
    }
  }, [pathname, replace]);

  useEffect(() => {
    if (data.language) {
      localStorage.setItem("lang", data.language);
    }
    if (!emptyState) {
      dispatch(setFichaInfoData({ ...data, isEdited: params.get("isEdited") }));
    } else {
      // setFichaInfoData is skipped here, so the theme has to be set directly.
      dispatch(setTheme(themeFromUniven(data.from_univen)));
    }
  }, []);

  useEffect(() => {
    dispatch(setInitialEditionData(edited_data));
    if (isEdition) {
      dispatch(setShowData("edited_data"));
    }
  }, [isEdition]);

  const addEditionStyle = () => (isEdition ? style.isEdition : "");

  if (emptyState) return <EmptyState data={data} />;

  return (
    <Box __css={{ marginBottom: "62px" }}>
      <ErrorCapture>
        <HeaderFI />
      </ErrorCapture>
      <ModalWarning />
      {!isImagesEdition ? (
        <Box className={style.bodyContainer}>
          <ErrorCapture>
            <Gallery />
          </ErrorCapture>
          <Box
            ref={refPropertiyDescContainer}
            className={style.propertyDescriptionContainer}
          >
            <Box
              id="fichaInfo_propertyDescription"
              className={`${style.leftSection}  ${addEditionStyle()}`}
            >
              <TitleProperty />
              <ErrorCapture>
                <PriceProperty />
              </ErrorCapture>
              <Atributes />
              <OperationsBlock />
              <Box
                __css={{ margin: "8px 0" }}
                className={`${style.inmoMobileContainer}  ${addEditionStyle()}`}
              >
                <ErrorCapture>
                  <Contact />
                </ErrorCapture>
                <FeedbackLike />
                <BookAVisitButton />
              </Box>
              <Temporary />
              <ErrorCapture>
                <BasicInformation />
              </ErrorCapture>
              <ErrorCapture>
                <Location />
              </ErrorCapture>
              <ImportantNote />
            </Box>
            <Box className={`${style.rigthSection} ${addEditionStyle()}`}>
              <ErrorCapture>
                <Contact />
              </ErrorCapture>
              <FeedbackLike />
              <BookAVisitButton />
            </Box>
          </Box>
          {/* <PoweredByTokko /> */}{" "}
          {/* Commented out as per design decision */}
        </Box>
      ) : (
        <Box className={style.bodyContainer}>
          <ErrorCapture>
            <ImagesEdition />
          </ErrorCapture>
        </Box>
      )}
      <ToastComponent />
    </Box>
  );
}
